import React from 'react';
import ActionprogresView from './actionprogres';
import ActionCustomerItem from './actioncustomeritem';
import ActionRow from './actionrow';
import Grid from '@mui/material/Grid';
import Alert from '@mui/material/Alert';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import EventNoteIcon from '@mui/icons-material/EventNote';
import { formatCurrency } from '../common/common';

const ActionsmonthView = (props) => {

    const getCompletion = (actions) => {
        //TODO: remember to check old pending which are not for current month
        let done = 0;
        for (let action of actions) {
            if (action.completed != null) {
                done++;
            }
        }
        return (done / actions.length) * 100;
    };

    const getNumberOfCompleted = (actions) => {
        return actions.filter((a) => a.completed != null).length;
    };

    const allCompleted = (actions) => {
        return getNumberOfCompleted(actions) === actions.length;
    };

    const getHeaderSx = () => {
        return props.warning
            ? { borderLeft: 4, borderColor: 'warning.main' }
            : { borderLeft: 4, borderColor: 'success.main' };
    };

    const getIconColor = () => {
        return props.warning ? 'warning.main' : 'success.main';
    };

    const getCompleted = () => {
        return props.actions.filter((a) => a.completed != null).sort((a, b) => (a.completed > b.completed ? -1 : 1));
    };

    return (
        <Accordion sx={getHeaderSx()} defaultExpanded={props.expanded}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Grid container alignItems="center">
                    <Grid item xs>
                        <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            {props.warning ? (
                                <WarningAmberIcon fontSize="small" sx={{ color: getIconColor() }} />
                            ) : (
                                <EventNoteIcon fontSize="small" sx={{ color: getIconColor() }} />
                            )}
                            {props.monthname}
                        </Typography>
                    </Grid>

                    {props.showProgress && !allCompleted(props.actions) && (
                        <Grid item xs={4} sm={6} sx={{ textAlign: 'center' }}>
                            <ActionprogresView
                                completion={getCompletion(props.actions)}
                                salesactual={props.sales.actual}
                                salespotential={props.sales.potential}
                                currency={props.currency}
                            />
                        </Grid>
                    )}

                    {!props.showProgress && (
                        <Grid item xs={4} sm={6}>
                            <span>Myyntipotentiaali: {formatCurrency(props.sales.potential, 2, props.currency)}</span>
                        </Grid>
                    )}

                    {allCompleted(props.actions) && (
                        <Grid item xs={4} sm={6}>
                            Myyntiarvio {formatCurrency(props.sales.potential, 2, props.currency)}
                        </Grid>
                    )}

                    {allCompleted(props.actions) && (
                        <Grid item xs sx={{ textAlign: 'right' }}>
                            <CheckCircleOutlineIcon sx={{ color: 'success.main' }} />
                        </Grid>
                    )}

                    {!allCompleted(props.actions) && (
                        <Grid item xs sx={{ textAlign: 'right' }}>
                            <Chip
                                size="small"
                                label={`${getNumberOfCompleted(props.actions)}/${props.actions.length}`}
                                sx={{ fontWeight: 500 }}
                            />
                        </Grid>
                    )}
                </Grid>
            </AccordionSummary>
            <AccordionDetails sx={{ display: 'block' }}>
                <Grid container>
                    {props.actions.length > 0 && (
                        <Grid item xs={12}>
                            {props.cusByLocCount.withcustomer.map((item) => (
                                <ActionCustomerItem
                                    key={item.id}
                                    customer={item}
                                    pendingOrders={props.pendingOrders}
                                    newOrderFromLocations={props.newOrderFromLocations}
                                    history={props.history}
                                />
                            ))}
                            {props.cusByLocCount.nocustomer.map((item) => (
                                <ActionRow
                                    key={item.id}
                                    type="info"
                                    action={item}
                                    showCustomer={true}
                                    newOrderFromLocations={props.newOrderFromLocations}
                                    history={props.history}
                                />
                            ))}
                        </Grid>
                    )}
                    {props.actions.length === 0 && (
                        <Grid item xs={12}>
                            <Alert severity="info">Ei muistutteita tälle kuukaudelle</Alert>
                        </Grid>
                    )}
                    {getNumberOfCompleted(props.actions) > 0 && (
                        <Grid item xs={12}>
                            <br />
                            <Accordion>
                                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                    <span style={{ fontSize: '1.4em', fontWeight: '500' }}>
                                        Suoritetut ({getNumberOfCompleted(props.actions)})
                                    </span>
                                </AccordionSummary>
                                <AccordionDetails sx={{ display: 'block' }}>
                                    {getCompleted().map((a) => (
                                        <ActionRow
                                            key={a.id}
                                            type="info"
                                            action={a}
                                            showCustomer={false}
                                            newOrderFromLocations={props.newOrderFromLocations}
                                            history={props.history}
                                        />
                                    ))}
                                </AccordionDetails>
                            </Accordion>
                        </Grid>
                    )}
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
};

export default ActionsmonthView;
